export const FILE_DOWNLOAD_OPEN_TYPES = {
  OPEN: "open",
  DOWNLOAD: "download",
};

export const FILE_UP_NAME = "fUp";
